import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  mainButton: {
    whiteSpace: 'nowrap',

    '& span': {
      whiteSpace: 'nowrap',
    },
  },

  changeStatusButton: {
    fontWeight: 500,
    borderColor: palette.primary.main,
    color: '#FF7C00',
    height: 40,
    width: 170,
    marginRight: 16,
  },

  buttonGroupContained: {
    minWidth: 140,
    boxShadow: 'none',
    marginRight: 16,

    '& button:first-child': {
      width: '100%',
    },
    '&:hover': {
      boxShadow: 'none',
    },
    '& button': {
      borderColor: palette.primary.main,
      color: '#FF7C00',
      background: '#FFF',
      border: `1px solid ${palette.primary.main}`,

      '&:hover': {
        boxShadow: 'none',
      },
    },
    '& button:hover': {
      borderColor: palette.primary.main,
      color: '#FF7C00',
      background: '#FFF',
    },

    '& button + button': {
      borderLeft: 'none',
    },
  },
}));

export default useStyles;
